
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/premium",
      function () {
        return require("private-next-pages/premium/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/premium"])
      });
    }
  